export default __webpack_public_path__ + "app/images/b2ee8c9bdf133a80512e52284c25821b.svg";